<template>
  <div class="bidder-page">
    <!-- 搜索区域 -->
    <div class="search-section">
        <el-form :model="searchForm" :inline="true" class="search-form">
          <el-form-item>
            <el-input v-model="searchForm.projectName" placeholder="招标项目名称" clearable style="width: 300px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="handleSearch">
              查询
            </el-button>
          </el-form-item>
          <el-form-item>
          </el-form-item>
        </el-form>
      </div>

    <!-- 提示信息 -->
    <!-- <div class="notice-section">
      <el-alert type="info" :closable="false" show-icon>
        <template slot="title">
          <div>
            <div>说明：1、平台技术服务费发票,自申请之日起七天内开具并发出。请开标后30天内申请发票,如不申请则自动开具电子普票</div>
            <div style="margin-top: 8px;">2、标书款发票由招标代理开具,如有疑问请咨询项目代理</div>
          </div>
        </template>
      </el-alert>
    </div> -->

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="orderNumber" label="订单编号" ></el-table-column>
        <el-table-column prop="orderType" label="订单类型" >
          <template slot-scope="scope">
            {{ getOrderTypeText(scope.row.orderType) }}
          </template>
        </el-table-column>
        <el-table-column prop="orderDate" label="订单日期" ></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="bidSectionName" label="标段名称"></el-table-column>
        <el-table-column prop="orderPrice" label="订单金额(元)"  align="right"></el-table-column>
        <el-table-column prop="contactPerson" label="联系人" ></el-table-column>
        <el-table-column prop="contactPhone" label="联系电话" ></el-table-column>
        <el-table-column prop="status" label="订单状态" min-width="50">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" size="mini">
              {{ getOrderStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-link v-if="scope.row.operation" type="primary" :underline="false" icon="el-icon-payment"
              @click="handlePay(scope.row)">
              {{ scope.row.operation }}
            </el-link>
            <span v-else>--</span>
            <el-link type="primary" size="small" @click="handleInvoice(scope.row)" style="margin-left: 8px;"
              v-if="scope.row.status == 1">开发票</el-link>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <div class="pagination-section">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <!-- 支付订单弹窗 -->
    <el-dialog title="可购标段列表信息" :visible.sync="paymentDialogVisible" width="80%" :close-on-click-modal="false"
      :append-to-body="true" class="payment-dialog">
      <div class="payment-content">
        <!-- 可购标段列表信息 -->
        <div class="section-info-section">
          <div class="section-title">可购标段列表信息</div>
          <div class="form-grid">
            <div class="form-column">
              <div class="form-item">
                <label>投标人名称：</label>
                <span class="form-value">{{ paymentForm.bidderName || '--' }}</span>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="paymentForm.contactPerson" placeholder="请输入投标联系人"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>电话：</label>
                <el-input v-model="paymentForm.phone" placeholder="请输入电话"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>通信地址：</label>
                <el-input v-model="paymentForm.address" placeholder="请输入通信地址"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标人开户行：</label>
                <el-input v-model="paymentForm.bank" placeholder="请输入开户行"></el-input>
              </div>
            </div>
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>开发票公司名称：</label>
                <el-input v-model="paymentForm.invoiceCompany" placeholder="请输入开发票公司名称"></el-input>
              </div>
              <div class="form-item">
                <label>购标日期：</label>
                <span class="form-value">{{ paymentForm.purchaseDate || '--' }}</span>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>手机：</label>
                <el-input v-model="paymentForm.mobile" placeholder="请输入手机号"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮编：</label>
                <el-input v-model="paymentForm.postalCode" placeholder="请输入邮编"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>银行账户：</label>
                <el-input v-model="paymentForm.bankAccount" placeholder="请输入银行账户"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮箱：</label>
                <el-input v-model="paymentForm.email" placeholder="请输入邮箱"></el-input>
              </div>
            </div>
          </div>
        </div>

        <!-- 费用明细 -->
        <div class="cost-details-section">
          <div class="section-title">费用明细</div>
          <div class="cost-table">
            <el-table :data="costDetails" border style="width: 100%">
              <el-table-column prop="no" label="NO." width="60"></el-table-column>
              <el-table-column prop="sectionCode" label="标段编码" min-width="200"></el-table-column>
              <el-table-column prop="sectionName" label="标段名称" min-width="300"></el-table-column>
              <el-table-column prop="price" label="招标文件售价(元)" width="140" align="right"></el-table-column>
              <el-table-column prop="paymentNote" label="线下缴费说明" min-width="250"></el-table-column>
            </el-table>
          </div>
          <div class="payment-summary">
            <div class="summary-row">
              <label>订单合计金额(元)(可能含有图纸押金)：</label>
              <el-input v-model="totalAmount" disabled style="width: 120px;"></el-input>
            </div>
            <div class="summary-row">
              <label>付款方式：</label>
                  <el-input value="线下支付" disabled style="width: 200px;"></el-input>
            </div>





            
            <div class="payment-notice">
              <p class="notice-text">当前支付方式为线下支付,付款后联系招标代理核实。</p>
              <p class="notice-text">选择线下支付,请上传相关付款凭证</p>
            </div>
          </div>
        </div>

        <!-- 文件上传 -->
        <div class="upload-section">
          <div class="section-title">文件上传</div>
          <div class="upload-area">
            <el-button type="primary" icon="el-icon-upload2" @click="handlePaymentUploadDocument">本地上传</el-button>
            <div class="el-upload__tip">支持的文件类型：PDF、Word、图片等，单个文件不能超过10GB</div>
          </div>
          <div class="uploaded-files">
            <el-table :data="uploadedFiles" border style="width: 100%">
              <el-table-column prop="fileName" label="文件名称" min-width="200"></el-table-column>
              <el-table-column prop="uploadTime" label="上传时间" width="150"></el-table-column>
              <el-table-column prop="uploader" label="上传人" width="120"></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <el-button type="text" size="small" @click="handleDeleteFile(scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="handlePaymentCancel">取消</el-button>
        <el-button type="primary" @click="handlePaymentConfirm">确定</el-button>
      </div>
    </el-dialog>

    <!-- 文件上传进度对话框 -->
    <el-dialog title="文件上传" :visible.sync="uploadProgress.visible" width="400px" :close-on-click-modal="false"
      :close-on-press-escape="false" :append-to-body="true" :show-close="false">
      <div class="upload-progress-content">
        <div class="upload-info">
          <i class="el-icon-upload" style="font-size: 24px; color: #409EFF; margin-right: 10px;"></i>
          <span>{{ uploadProgress.fileName }}</span>
        </div>
        <el-progress :percentage="uploadProgress.percentage"
          :status="uploadProgress.status === 'success' ? 'success' : (uploadProgress.status === 'error' ? 'exception' : null)"
          style="margin-top: 20px;">
        </el-progress>
        <div class="upload-status" style="margin-top: 10px; text-align: center;">
          <span v-if="uploadProgress.status === 'uploading'">正在上传...</span>
          <span v-else-if="uploadProgress.status === 'success'" style="color: #67C23A;">上传成功</span>
          <span v-else-if="uploadProgress.status === 'error'" style="color: #F56C6C;">上传失败</span>
        </div>
      </div>
    </el-dialog>

    <!-- 开发票弹窗 -->
    <el-dialog title="开具发票" :visible.sync="invoiceDialogVisible" width="60%" :append-to-body="true"
      :close-on-click-modal="false" :close-on-press-escape="false" class="invoice-dialog">
      <template slot="title">
        <div class="dialog-header">
          <span class="dialog-title">开具发票</span>
        </div>
      </template>

      <div class="invoice-content">
        <!-- 项目信息 -->
        <div class="info-section">
          <div class="section-title">项目信息</div>
          <div class="info-grid">
            <div class="info-item">
              <label>订单编号：</label>
              <span>{{ currentInvoiceOrder.orderNumber || '--' }}</span>
            </div>
            <div class="info-item">
              <label>项目名称：</label>
              <span>{{ currentInvoiceOrder.projectName || '--' }}</span>
            </div>
            <div class="info-item">
              <label>标段名称：</label>
              <span>{{ currentInvoiceOrder.bidSectionName || '--' }}</span>
            </div>
            <div class="info-item">
              <label>订单类型：</label>
              <span>{{ getOrderTypeText(currentInvoiceOrder.orderType) }}</span>
            </div>
            <div class="info-item">
              <label>订单金额：</label>
              <span>{{ currentInvoiceOrder.orderPrice || 0 }} 元</span>
            </div>
            <div class="info-item">
              <label>联系人：</label>
              <span>{{ currentInvoiceOrder.contactPerson || '--' }}</span>
            </div>
          </div>
        </div>

        <!-- 发票信息 -->
        <div class="invoice-info-section">
          <div class="section-title">发票信息</div>
          <div class="form-grid">
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>发票类型：</label>
                <el-select v-model="invoiceForm.invoiceType" placeholder="请选择发票类型" style="width: 100%;">
                  <el-option label="增值税普通发票" value="ordinary"></el-option>
                  <el-option label="增值税专用发票" value="special"></el-option>
                </el-select>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>发票抬头：</label>
                <el-input v-model="invoiceForm.invoiceTitle" placeholder="请输入发票抬头"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>纳税人识别号：</label>
                <el-input v-model="invoiceForm.taxpayerId" placeholder="请输入纳税人识别号"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>开户行：</label>
                <el-input v-model="invoiceForm.bankName" placeholder="请输入开户行"></el-input>
              </div>
            </div>
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>开户账号：</label>
                <el-input v-model="invoiceForm.bankAccount" placeholder="请输入开户账号"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>单位地址：</label>
                <el-input v-model="invoiceForm.companyAddress" placeholder="请输入单位地址"></el-input>
              </div>
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>发票联系电话：</label>
                <el-input v-model="invoiceForm.companyPhone" placeholder="请输入发票联系电话"></el-input>
              </div>
            </div>
          </div>
        </div>

        <!-- 电子发票发送方式 -->
        <div class="invoice-info-section">
          <div class="section-title">电子发票发送方式</div>
          <div class="form-grid">
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>投标联系人：</label>
                <el-input v-model="invoiceForm.contactName" placeholder="请输入投标联系人"></el-input>
              </div>
            </div>
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>联系电话：</label>
                <el-input v-model="invoiceForm.contactPhone" placeholder="请输入联系电话"></el-input>
              </div>
            </div>
          </div>
          <div class="form-grid" style="margin-top: 10px;">
            <div class="form-column">
              <div class="form-item">
                <label><span style="color: #f56c6c;padding-right: 5px;">*</span>邮箱：</label>
                <el-input v-model="invoiceForm.contactEmail" placeholder="请输入邮箱地址"></el-input>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="closeInvoiceDialog">取消</el-button>
        <el-button type="primary" @click="handleInvoiceConfirm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getOrderList, getOrderDetail, submitOrder, invoiceInfo,submitInvoiceInfo } from '@/api/tenderNotice/api'
import { UPLOAD_CONSTANTS, timeUtils } from '@/utils/base'
import { doFileUpload } from '@/utils/fileUploadHelper'

export default {
  name: 'MyOrders',
  data() {
    return {
      searchForm: {
        projectName: ''
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      paymentDialogVisible: false,
      currentOrder: null,
      paymentForm: {
        bidderName: '',
        contactPerson: '',
        phone: '',
        address: '',
        bank: '',
        invoiceCompany: '',
        mobile: '',
        postalCode: '',
        bankAccount: '',
        paymentMethod: 'offline',
        purchaseDate: '',
        email: ''
      },
      costDetails: [],
      totalAmount: 0,
      fileList: [],
      uploadedFiles: [],
      fileBindId: '',
      uploadProgress: {
        visible: false,
        percentage: 0,
        fileName: '',
        status: null
      },
      invoiceDialogVisible: false,
      currentInvoiceOrder: {},
      invoiceForm: {
        invoiceType: '',
        invoiceTitle: '',
        taxpayerId: '',
        bankName: '',
        bankAccount: '',
        companyAddress: '',
        companyPhone: '',
        contactEmail: '',
        contactName: '',
        contactPhone: ''
      }
    }
  },
  mounted() {
    this.loadOrderList()
    this.fileBindId = Date.now().toString()
  },
  methods: {

    handleInvoice(row) {

      this.getInvoiceInfo(row)

      this.currentInvoiceOrder = {
        orderNumber: row.orderNumber || '',
        projectName: row.projectName || '',
        bidSectionName: row.bidSectionName || '',
        orderType: row.orderType || '',
        orderPrice: row.orderPrice || 0,
        contactPerson: row.contactPerson || '',
        contactPhone: row.contactPhone || ''
      }
      // 重置表单
      this.invoiceForm = {
        invoiceType: '',
        invoiceTitle: '',
        taxpayerId: '',
        bankName: '',
        bankAccount: '',
        companyAddress: '',
        companyPhone: '',
        contactEmail: '',
        contactName: '',
        contactPhone: ''
      }
      this.invoiceDialogVisible = true
    },
    //  获取发票详情
    getInvoiceInfo(row) {
      invoiceInfo({
        orderNumber: row.orderNumber
      }).then(res => {
        if (res.code == 200) {
          const data = res.data
          // 映射接口返回的字段到表单
          this.invoiceForm = {
            invoiceType: data.invoiceType || '',
            invoiceTitle: data.invoiceTitle || '',
            taxpayerId: data.taxpayerId || '',
            bankName: data.bankName || '',
            bankAccount: data.bankAccount || '',
            companyAddress: data.companyAddress || '',
            companyPhone: data.companyPhone || '',
            contactEmail: data.contactEmail || '',
            contactName: data.contactName || '',
            contactPhone: data.contactPhone || ''
          }
        }
      }).catch(error => {
        console.error('获取发票详情失败:', error)
        this.$message.error('获取发票详情失败')
      })
    },

    // 关闭开发票弹窗
    closeInvoiceDialog() {
      this.invoiceDialogVisible = false
      this.resetInvoiceForm()
    },

    // 重置发票表单
    resetInvoiceForm() {
      this.currentInvoiceOrder = {}
      this.invoiceForm = {
        invoiceType: '',
        invoiceTitle: '',
        taxpayerId: '',
        bankName: '',
        bankAccount: '',
        companyAddress: '',
        companyPhone: '',
        contactEmail: '',
        contactName: '',
        contactPhone: ''
      }
    },

    // 确认提交发票
    async handleInvoiceConfirm() {
      if (!this.validateInvoiceForm()) {
        return
      }

      try {
        const res = await submitInvoiceInfo({
          orderNumber: this.currentInvoiceOrder.orderNumber,
          invoiceType: this.invoiceForm.invoiceType,
          invoiceTitle: this.invoiceForm.invoiceTitle,
          taxpayerId: this.invoiceForm.taxpayerId,
          bankName: this.invoiceForm.bankName,
          bankAccount: this.invoiceForm.bankAccount,
          companyAddress: this.invoiceForm.companyAddress,
          companyPhone: this.invoiceForm.companyPhone,
          contactName: this.invoiceForm.contactName,
          contactPhone: this.invoiceForm.contactPhone,
          contactEmail: this.invoiceForm.contactEmail
        })
        
        if (res.code == 200) {
          this.$message.success('发票申请提交成功')
          this.closeInvoiceDialog()
          this.loadOrderList()
        } else {
          this.$message.error(res.msg || '提交发票申请失败')
        }
      } catch (error) {
        console.error('提交发票申请失败:', error)
        this.$message.error(error.msg || '提交发票申请失败')
      }
    },

    // 验证发票表单
    validateInvoiceForm() {
      if (!this.invoiceForm.invoiceType) {
        this.$message.error('请选择发票类型')
        return false
      }
      if (!this.invoiceForm.invoiceTitle || !this.invoiceForm.invoiceTitle.trim()) {
        this.$message.error('请输入发票抬头')
        return false
      }
      if (!this.invoiceForm.taxpayerId || !this.invoiceForm.taxpayerId.trim()) {
        this.$message.error('请输入纳税人识别号')
        return false
      }
      if (!this.invoiceForm.bankName || !this.invoiceForm.bankName.trim()) {
        this.$message.error('请输入开户行')
        return false
      }
      if (!this.invoiceForm.bankAccount || !this.invoiceForm.bankAccount.trim()) {
        this.$message.error('请输入开户账号')
        return false
      }
      if (!this.invoiceForm.companyAddress || !this.invoiceForm.companyAddress.trim()) {
        this.$message.error('请输入单位地址')
        return false
      }
      if (!this.invoiceForm.companyPhone || !this.invoiceForm.companyPhone.trim()) {
        this.$message.error('请输入发票联系电话')
        return false
      }
      if (!this.invoiceForm.contactName || !this.invoiceForm.contactName.trim()) {
        this.$message.error('请输入投标联系人')
        return false
      }
      if (!this.invoiceForm.contactPhone || !this.invoiceForm.contactPhone.trim()) {
        this.$message.error('请输入联系电话')
        return false
      }
      if (!this.invoiceForm.contactEmail || !this.invoiceForm.contactEmail.trim()) {
        this.$message.error('请输入邮箱地址')
        return false
      }

      // 邮箱格式验证
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailReg.test(this.invoiceForm.contactEmail)) {
        this.$message.error('请输入正确的邮箱格式')
        return false
      }

      // 纳税人识别号格式验证（15-20位字母或数字，支持大小写）
      const taxpayerIdReg = /^[A-Za-z0-9]{15,20}$/
      if (!taxpayerIdReg.test(this.invoiceForm.taxpayerId)) {
        this.$message.error('请输入正确的纳税人识别号格式（15-20位字母或数字）')
        return false
      }

      return true
    },
    getOrderTypeText(orderType) {
      const typeMap = {
        1: '标书款',
        2: '平台服务费'
      }
      return typeMap[orderType] || '未知类型'
    },

    getOrderStatusText(status) {
      const statusMap = {
        0: '待支付',
        1: '已支付',
        2: '退款',
        3: '已上传支付凭证待审核'
      }
      return statusMap[status] || '未知状态'
    },

    getStatusTagType(status) {
      const typeMap = {
        0: 'danger',
        1: 'success',
        2: 'info',
        3: 'warning'
      }
      return typeMap[status] || ''
    },

    // 加载订单列表
    loadOrderList() {
      getOrderList({
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        projectName: this.searchForm.projectName
      }).then(res => {
        if (res.data.records) {
          this.tableData = res.data.records
          this.total = res.data.total || 0
        } else {
          this.tableData = []
          this.total = 0
        }
      }).catch(error => {
        console.error('获取订单列表失败:', error)
        this.$message.error('获取订单列表失败')
        this.tableData = []
        this.total = 0
      })
    },

    // 处理支付按钮点击
    handlePay(row) {

      console.log(row);
      





      // 标书款 + 待支付 的订单不允许在此页面操作
      if (row.orderType === 1 && row.status === 0) {
        this.$message.warning('标书款待支付订单请联系项目代理处理，当前页面不支持操作')
        return
      }

      // 判断订单状态
      // 0: 待支付
      // 1: 已支付
      // 2: 退款
      // 3: 已上传支付凭证待审核
      if (row.status === 1) {
        this.$message.error('订单已支付，无法支付')
        return
      }
      if (row.operation.includes('上传')) {
        this.getOrderDetail(row)
        return
      }
      if (row.operation.includes('支付')) {
        this.$router.push({ path: '/bidderHome/technologyFee', query: { sectionCode: row.bidSectionCode } })
        return
      }
    },

    // 获取订单详情
    async getOrderDetail(row) {
      try {
        const response = await getOrderDetail({
          orderNumber: row.orderNumber
        })

        if (this.isSuccessResponse(response)) {
          this.openPaymentDialog(row, response.data)
        } else {
          this.$message.error(response.message || '获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败')
      }
    },

    isSuccessResponse(response) {
      return response && (response.code === 200 || response.code === 0)
    },

    // 打开支付订单弹窗
    openPaymentDialog(row, data) {
      this.currentOrder = {
        orderNumber: row.orderNumber,
        bidSectionCode: data.bidSectionCode || '',
        ...data
      }

      // 字段名可能不一样，兼容处理
      this.paymentForm = {
        bidderName: data.bidderName || data.tendereeName || row.contactPerson || '',
        contactPerson: data.relationUser || '',
        phone: data.userTel || '',
        address: data.address || '',
        bank: data.bankName || '',
        invoiceCompany: data.invoiceName || data.billingCompany || '',
        mobile: data.userPhone || '',
        postalCode: data.postalCode || '',
        bankAccount: data.bankAccount || '',
        paymentMethod: this.convertPayTypeToMethod(data.payType),
        purchaseDate: data.buyBidTime || data.purchaseDate || timeUtils.getCurrentTime(),
        email: data.email || ''
      }

      this.initCostDetails(data)
      this.initUploadedFiles(data)
      this.paymentDialogVisible = true
    },

    // 初始化费用明细
    initCostDetails(data) {
      if (data.bidSectionCode || data.bidSectionName) {
        // 单个标段
        this.costDetails = [{
          no: 1,
          sectionCode: data.bidSectionCode || '',
          sectionName: data.bidSectionName || '',
          price: data.tenderFee || 0,
          paymentNote: data.paymentInstructions || ''
        }]
        this.totalAmount = data.orderPrice || (data.tenderFee || 0)
      } else if (data.sections && Array.isArray(data.sections)) {
        // 多个标段
        this.costDetails = data.sections.map((section, index) => ({
          no: index + 1,
          sectionCode: section.bidSectionCode || section.sectionCode || '',
          sectionName: section.bidSectionName || section.sectionName || '',
          price: section.tenderFee || section.documentPrice || 0,
          paymentNote: section.paymentInstructions || section.offlinePaymentNote || ''
        }))
        this.totalAmount = data.orderPrice || 0
      } else {
        this.costDetails = []
        this.totalAmount = data.orderPrice || 0
      }
    },

    // 初始化已上传的文件列表
    initUploadedFiles(data) {
      if (data.uploadFiles && Array.isArray(data.uploadFiles)) {
        this.uploadedFiles = data.uploadFiles.map(file => ({
          fileName: file.fileName || file.name || '',
          uploadTime: file.uploadTime || file.createTime || '',
          uploader: file.uploader || '系统',
          fileId: file.uploadFileId || file.id || ''
        }))
      } else {
        this.uploadedFiles = []
      }
    },
    // 转换支付类型为方法值
    convertPayTypeToMethod(payType) {
      return payType === 1 ? 'offline' : (payType === 2 ? 'online' : 'offline')
    },

    // 取消支付订单
    handlePaymentCancel() {
      this.paymentDialogVisible = false
      this.resetPaymentForm()
    },

    // 确认支付订单
    async handlePaymentConfirm() {
      if (!this.validatePaymentForm()) {
        return
      }

      try {
        await this.submitPaymentOrder()
        this.$message.success('支付订单提交成功')
        this.paymentDialogVisible = false
        this.resetPaymentForm()
        this.loadOrderList()
      } catch (error) {
        console.error('提交支付订单失败:', error)
        this.$message.error(error.message || '提交支付订单失败')
      }
    },

    // 提交支付订单
    async submitPaymentOrder() {
      if (!this.currentOrder) {
        throw new Error('订单信息丢失，请重新选择')
      }

      const form = this.paymentForm
      const uploadFiles = this.uploadedFiles
        .map(file => ({ uploadFileId: file.fileId || '' }))
        .filter(file => file.uploadFileId)

      const requestData = {
        relationUser: form.contactPerson || '',
        userTel: form.phone || '',
        userPhone: form.mobile || '',
        postalCode: form.postalCode || '',
        address: form.address || '',
        buyBidTime: form.purchaseDate || '',
        payType: form.paymentMethod === 'offline' ? 1 : 2,
        uploadFiles: uploadFiles,
        email: form.email || '',
        billingCompany: form.invoiceCompany || '',
        sectionCode: this.currentOrder.bidSectionCode || ''
      }

      const response = await submitOrder(requestData)

      if (this.isSuccessResponse(response)) {
        return response.data
      } else {
        throw new Error(response.message || '提交订单失败')
      }
    },

    // 重置支付表单
    resetPaymentForm() {
      this.currentOrder = null
      this.paymentForm = {
        bidderName: '',
        contactPerson: '',
        phone: '',
        address: '',
        bank: '',
        invoiceCompany: '',
        mobile: '',
        postalCode: '',
        bankAccount: '',
        paymentMethod: 'offline',
        purchaseDate: '',
        email: ''
      }
      this.fileList = []
      this.uploadedFiles = []
      this.costDetails = []
      this.totalAmount = 0
      this.fileBindId = Date.now().toString()
    },

    // 验证支付表单
    validatePaymentForm() {
      const requiredFields = [
        { field: 'contactPerson', name: '投标联系人' },
        { field: 'phone', name: '电话' },
        { field: 'address', name: '通信地址' },
        { field: 'bank', name: '投标人开户行' },
        { field: 'invoiceCompany', name: '开发票公司名称' },
        { field: 'mobile', name: '手机' },
        { field: 'postalCode', name: '邮编' },
        { field: 'bankAccount', name: '银行账户' },
        { field: 'email', name: '邮箱' }
      ]

      for (const item of requiredFields) {
        if (!this.paymentForm[item.field] || !this.paymentForm[item.field].trim()) {
          this.$message.error(`请填写${item.name}`)
          return false
        }
      }

      // 邮箱验证
      const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      if (!emailReg.test(this.paymentForm.email)) {
        this.$message.error('请输入正确的邮箱格式')
        return false
      }

      // 手机号验证
      const mobileReg = /^1[3-9]\d{9}$/
      if (!mobileReg.test(this.paymentForm.mobile)) {
        this.$message.error('请输入正确的手机号格式')
        return false
      }

      return true
    },

    handlePaymentUploadDocument() {
      this.createFileInput()
    },

    createFileInput() {
      const input = document.createElement('input')
      input.type = 'file'
      input.accept = UPLOAD_CONSTANTS.SUPPORTED_FILE_TYPES
      input.onchange = (e) => {
        this.handleFileSelect(e)
      }
      input.click()
    },

    async handleFileSelect(event) {
      const file = event.target.files[0]
      if (!file) return

      if (!this.validateFile(file)) {
        return
      }

      try {
        this.showUploadProgress(file)
        const uploadResult = await this.uploadFileWithChunks(file)
        this.handleUploadResult(uploadResult, file)
      } catch (error) {
        this.handleUploadError(error, file)
      }
    },

    validateFile(file) {
      const maxSize = 102400 * 1024 * 1024 // 10GB
      if (file.size > maxSize) {
        this.$message.error('文件大小不能超过10GB')
        return false
      }

      const allowedTypes = UPLOAD_CONSTANTS.SUPPORTED_FILE_TYPES.split(',')
      const fileExtension = '.' + file.name.split('.').pop().toLowerCase()
      if (!allowedTypes.includes(fileExtension)) {
        this.$message.error('不支持的文件类型')
        return false
      }

      return true
    },

    showUploadProgress(file) {
      this.uploadProgress = {
        visible: true,
        percentage: 0,
        fileName: file.name,
        status: UPLOAD_CONSTANTS.STATUS.UPLOADING
      }
    },
    

    //处理上传结果
    handleUploadResult(uploadResult, file) {
      if (uploadResult && uploadResult.success) {
        this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.SUCCESS
        this.uploadProgress.percentage = 100

        const fileId = uploadResult.fileId || uploadResult.id || ''
        if (fileId) {
          this.uploadedFiles.push({
            fileName: file.name,
            uploadTime: new Date().toLocaleString(),
            uploader: '当前用户',
            fileId: fileId
          })
        }
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.success(`文件 ${file.name} 上传成功`)
        }, 1000)
      } else {
        this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.ERROR
        setTimeout(() => {
          this.uploadProgress.visible = false
          this.$message.error(`文件上传失败: ${uploadResult?.message || '未知错误'}`)
        }, 1000)
      }
    },
    //处理上传错误
    handleUploadError(error, file) {
      this.uploadProgress.status = UPLOAD_CONSTANTS.STATUS.ERROR
      setTimeout(() => {
        this.uploadProgress.visible = false
        this.$message.error(`文件上传失败: ${error.message || '未知错误'}`)
      }, 1000)
    },
    //上传文件
    async uploadFileWithChunks(file) {
      let uploadedFileId = null

      const uploadResult = await doFileUpload(file, {
        fileBindId: this.fileBindId,
        onProgress: (progress) => {
          this.uploadProgress.percentage = Math.round(Number(progress) || 0)
        },
        onSuccess: (r) => {
          uploadedFileId = r.fileId || r.id || ''
        },
        onError: () => { }
      })

      if (uploadResult && uploadedFileId) {
        uploadResult.fileId = uploadedFileId
      }

      return uploadResult
    },

    //删除文件
    handleDeleteFile(row) {
      this.$confirm('确定要删除这个文件吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.uploadedFiles.findIndex(item => item.fileId === row.fileId)
        if (index > -1) {
          this.uploadedFiles.splice(index, 1)
          this.$message.success('删除成功')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },

    handleSearch() {
      this.currentPage = 1
      this.loadOrderList()
    },

    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.loadOrderList()
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.loadOrderList()
    }
  }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.bidder-page {
  .apply-minimal-gray-theme();
}

/* 提示信息区域 */
.notice-section {
  margin-bottom: 20px;
  
  /deep/ .el-alert {
    border-radius: 4px;
    border-left: 3px solid @info-color;
  }
}

/* 支付订单弹窗样式 */
.payment-dialog {
  /deep/ .el-dialog__header {
    background: @gray-50;
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
  }

  /deep/ .el-dialog__title {
    font-size: 17px;
    font-weight: 600;
    color: @gray-800;
  }

  /deep/ .el-dialog__body {
    padding: 24px;
    max-height: 70vh;
    overflow-y: auto;
    background: @gray-50;
  }
}

.payment-content .section-info-section,
.payment-content .cost-details-section,
.payment-content .upload-section {
  margin-bottom: 25px;
}

.payment-content .section-title {
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 8px;
}

.payment-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.payment-content .form-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.payment-content .form-item {
  display: flex;
  align-items: center;
}

.payment-content .form-item label {
  min-width: 140px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  flex-shrink: 0;
}

.payment-content .form-item .el-input {
  flex: 1;
}

.payment-content .form-value {
  color: #666;
  font-size: 14px;
}

/* 费用明细表格样式 */
.payment-content .cost-table {
  margin-bottom: 20px;
}

.payment-content .payment-summary {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
}

.payment-content .summary-row {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}

.payment-content .summary-row:last-child {
  margin-bottom: 0;
}

.payment-content .summary-row label {
  min-width: 200px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
}

.payment-content .payment-notice {
  margin-top: 15px;
  padding-top: 15px;
  border-top: 1px solid #e4e7ed;
}

.payment-content .payment-notice .notice-text {
  color: #f56c6c;
  font-size: 14px;
  margin: 5px 0;
  line-height: 1.5;
}

/* 文件上传样式 */
.payment-content .upload-area {
  margin-bottom: 20px;
}

.payment-content .uploaded-files {
  margin-top: 10px;
}

.payment-content .no-files {
  text-align: center;
  color: #999;
  font-size: 14px;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 4px;
}

/* 上传进度弹窗样式 */
.upload-progress-content {
  padding: 20px;
}

.upload-progress-content .upload-info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.upload-progress-content .upload-info span {
  font-size: 14px;
  color: #333;
}

.upload-progress-content .upload-status {
  font-size: 14px;
}

/* 弹窗底部按钮样式 */
.payment-dialog {
  /deep/ .el-dialog__footer {
    text-align: center;
    padding: 16px 24px;
    border-top: 1px solid @gray-200;
    background: #fff;
  }
}

.dialog-footer {
  /deep/ .el-button {
    margin: 0 10px;
    min-width: 100px;
    transition: all @transition-base ease;

    &:hover {
      transform: translateY(-1px);
    }
  }
}

/* 开发票弹窗样式 */
.invoice-dialog {
  /deep/ .el-dialog__header {
    padding: 20px 24px;
    border-bottom: 1px solid @gray-200;
    background: @gray-50;
  }
}

.invoice-dialog .dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.invoice-dialog .dialog-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.invoice-content {
  padding: 20px 0;
}

/* 信息展示区域 */
.invoice-content .info-section {
  margin-bottom: 30px;
}

.invoice-content .section-title {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e8e8e8;
}

.invoice-content .info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px 40px;
}

.invoice-content .info-item {
  display: flex;
  align-items: center;
  line-height: 32px;
}

.invoice-content .info-item label {
  min-width: 100px;
  color: #333;
  font-size: 14px;
  font-weight: normal;
  margin-right: 10px;
  flex-shrink: 0;
}

.invoice-content .info-item span {
  color: #666;
  font-size: 14px;
}

/* 发票信息区域 */
.invoice-content .invoice-info-section {
  margin-bottom: 30px;
}

.invoice-content .form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.invoice-content .form-column {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.invoice-content .form-item {
  display: flex;
  align-items: center;
}

.invoice-content .form-item label {
  min-width: 140px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  flex-shrink: 0;
}

.invoice-content .form-item .el-input,
.invoice-content .form-item .el-select {
  flex: 1;
}

/* 邮箱区域 */
.invoice-content .email-section {
  margin-bottom: 20px;
}

.invoice-content .email-section .form-item {
  display: flex;
  align-items: center;
}

.invoice-content .email-section .form-item label {
  min-width: 140px;
  font-size: 14px;
  color: #333;
  margin-right: 10px;
  flex-shrink: 0;
}

/* 弹窗底部按钮 */
.invoice-dialog {
  /deep/ .el-dialog__footer {
    text-align: center;
    padding: 16px 24px;
    border-top: 1px solid @gray-200;
    background: #fff;
  }
}
</style>
